<template>
  <Skeleton
    class="m-top-leagues"
    :loading="loading"
    empty-size="small"
    @retry="fetchData"
  >
    <!-- matches list -->
    <template v-if="hasData">
      <template v-for="(tournament, index) in topLeagues">
        <Leagues
          :key="`${tournament.tournamentId}_${index}`"
          :tournament="tournament"
          :current-market-id="currentMarketId"
          canjump
        />
      </template>

      <ViewAll
        :url="viewAllUrl"
        :count="topLeaguesCount"
      />
    </template>
  </Skeleton>
</template>

<script>
import { storeToRefs } from 'pinia'
import Leagues from 'wap/match/Leagues.vue'
import ViewAll from '../components/ViewAll'
import useHomeStore from 'wap/stores/home'

export default {
  name: 'TopLeagues',
  components: {
    Leagues,
    ViewAll
  },
  props: {
    sportId: {
      type: String,
      default: ''
    },
    sportName: {
      type: String,
      default: ''
    },
    currentMarketId: {
      type: [String, Number],
      default: ''
    },
    // 是否被父级代理请求
    proxyed: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    const { topLeagues, topLeaguesCount } = storeToRefs(useHomeStore())
    return { topLeagues, topLeaguesCount }
  },
  data () {
    return {
      loading: false // true, false -1: 加载失败
    }
  },
  computed: {
    hasData () {
      return this.topLeagues.length
    },
    viewAllUrl () {
      return {
        name: 'matchList',
        params: {
          sportName: encodeURIComponent(this.sportName)
        },
        query: {
          type: '2'
        }
      }
    }
  },
  watch: {
    sportId () {
      this.fetchData()
    }
  },
  created () {
    if (!this.proxyed) {
      if (this.hasData) {
        useHomeStore().getTopLeagues(this.sportId).catch(() => ({}))
      } else {
        this.fetchData()
      }
    }
  },
  activated () {
    if (this.hasData) {
      useHomeStore().getTopLeagues(this.sportId).catch(() => ({}))
    }
  },
  destroyed () {
    useHomeStore().resetTopLeagues()
  },
  methods: {
    async fetchData () {
      this.loading = true
      try {
        await useHomeStore().getTopLeagues(this.sportId)
        this.loading = false
      } catch (error) {
        if (error === 'canceled') return
        this.loading = -1
      }
    }
  }
}
</script>
